import { render } from "./TabBriefcase.vue?vue&type=template&id=27839cd0"
import script from "./TabBriefcase.vue?vue&type=script&lang=js"
export * from "./TabBriefcase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__